import { useTheme } from '@/stores/theme';

export function ThemeObserver() {
  useTheme();
  return null;
}
